module.exports = __webpack_public_path__ + "static/media/r3.b2b47a5e.png";